import { GetterTree } from 'vuex';
import { State } from './wsm.store';

const getters: GetterTree<State, State> = {
  getCurrentWSM: state => {
    return state.currentWSMType;
  },
  getCurrentWSMService: state => {
    return state.currentWSMService;
  },
  getWSMServices: state => {
    return state.wsmServices;
  }
};

export default getters;
